// extracted by mini-css-extract-plugin
export var sliderRange = "_o7-2";
export var sliderRoot = "_o7-0";
export var sliderThumb = "_o7-3";
export var sliderTrack = "_o7-1";